const ENV_MAPPING = {
  prod: {
    url: 'https://api.biztech.avalara.com',
    title: 'Production'
  },
  fqa: {
    url: 'https://api.fqa.biztech.avalara.net',
    title: 'FQA'
  },
  sandbox: {
    url: 'https://api.biztech-sandbox.com',
    title: 'Sandbox'
  },
  cqa: {
    url: 'https://api.cqa.biztech.avalara.net',
    title: 'CQA'
  }
};

export default ENV_MAPPING;
